import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaPushWelcomeForm from "./components/MfaPushWelcomeForm";
import { useMfaPushWelcomeManager } from "./hooks/useMfaPushWelcomeManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaPushWelcomeScreen() {
    // Extracting attributes from hook made out of MfaPushWelcome instance of Auth0 React ACUL SDK
    const { texts, locales, mfaPushWelcome } = useMfaPushWelcomeManager();

    applyAuth0Theme(mfaPushWelcome);
    return (
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <MfaPushWelcomeForm />

        </AuthLayout>
    );
}

export default MfaPushWelcomeScreen;
